

import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'


import Vconsole17Open21 from './components/Open22.vue'
registerVueComponentAndAngularBindings('vconsole17:open21:page', 'vconsole17Open21', Vconsole17Open21)